import * as React from "react";
import { FaCreditCard } from "react-icons/fa";
import { styled } from "../../styled";
import { UnionPayLogo, AmericanExpressLogo, DinersClubLogo, DiscoverLogo, JcbLogo, MastercardLogo, VisaLogo, } from "../icons/logos";
const Icon = styled("div") `
	font-size: 50px;
	color: ${({ theme }) => theme.color.primary};
`;
export const CreditCardIcon = (props) => {
    switch (props.card_brand) {
        case "amex":
            return React.createElement(AmericanExpressLogo, null);
        case "diners":
            return React.createElement(DinersClubLogo, null);
        case "discover":
            return React.createElement(DiscoverLogo, null);
        case "jcb":
            return React.createElement(JcbLogo, null);
        case "mastercard":
            return React.createElement(MastercardLogo, null);
        case "unionpay":
            return React.createElement(UnionPayLogo, null);
        case "visa":
            return React.createElement(VisaLogo, null);
        case "unknown":
            return (React.createElement(Icon, { style: { fontSize: "50px" } },
                React.createElement(FaCreditCard, null)));
        default:
            return React.createElement(React.Fragment, null, " ");
    }
};
//# sourceMappingURL=credit-card-logo.js.map